import React from 'react';
import PortalHeader from '../../components/PortalHeader/PortalHeader';
import PageContainer from '../../components/PageElements/PageContainer/PageContainer';
import PageBody from '../../components/PageElements/PageBody/PageBody';
import styles from './Pricing.module.css';

const Pricing: React.FC = () => {
  const handleSubscribe = () => {
    // TODO: Implement Stripe subscription flow
    console.log('Subscribe clicked');
  };

  return (
    <PageContainer>
      <PortalHeader 
        showContentHeader={false}
      />
      <PageBody>
        <div className={styles.container}>
          <div className={styles.header}>
            <h1 className={styles.title}>Simple, Transparent Pricing</h1>
            <p className={styles.subtitle}>
              Pay only for what you use. No hidden fees, no surprises.
            </p>
          </div>

          <div className={styles.pricingCard}>
            <div className={styles.cardHeader}>
              <h2 className={styles.planName}>Usage-Based Pricing</h2>
              <p className={styles.planDescription}>
                One simple pricing structure that scales with your business
              </p>
            </div>

            <div className={styles.pricingTiers}>
              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>0 - 1,000 calls</span>
                  <span className={styles.tierPrice}>FREE</span>
                </div>
                <p className={styles.tierDescription}>
                  Perfect for small restaurants and testing
                </p>
              </div>

              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>1,001 - 10,000 calls</span>
                  <span className={styles.tierPrice}>$0.01 per call</span>
                </div>
                <p className={styles.tierDescription}>
                  Small to medium businesses
                </p>
              </div>

              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>10,001 - 100,000 calls</span>
                  <span className={styles.tierPrice}>$0.005 per call</span>
                </div>
                <p className={styles.tierDescription}>
                  Growing restaurants and regional chains
                </p>
              </div>

              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>100,001 - 1M calls</span>
                  <span className={styles.tierPrice}>$0.002 per call</span>
                </div>
                <p className={styles.tierDescription}>
                  Large restaurant chains
                </p>
              </div>

              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>1M - 10M calls</span>
                  <span className={styles.tierPrice}>$0.001 per call</span>
                </div>
                <p className={styles.tierDescription}>
                  Enterprise platforms
                </p>
              </div>

              <div className={styles.tier}>
                <div className={styles.tierHeader}>
                  <span className={styles.tierRange}>10M+ calls</span>
                  <span className={styles.tierPrice}>$0.0005 per call</span>
                </div>
                <p className={styles.tierDescription}>
                  Large-scale platforms (DoorDash, UberEats scale)
                </p>
              </div>
            </div>

            <div className={styles.examples}>
              <h3 className={styles.examplesTitle}>Real Examples</h3>
              <div className={styles.exampleGrid}>
                <div className={styles.example}>
                  <h4>Single Location</h4>
                  <p>~5,000 calls/month</p>
                  <span className={styles.exampleCost}>$40/month</span>
                </div>
                <div className={styles.example}>
                  <h4>Multi-Location</h4>
                  <p>~50,000 calls/month</p>
                  <span className={styles.exampleCost}>$290/month</span>
                </div>
                <div className={styles.example}>
                  <h4>Enterprise</h4>
                  <p>~500,000 calls/month</p>
                  <span className={styles.exampleCost}>$1,890/month</span>
                </div>
              </div>
            </div>

            <div className={styles.features}>
              <h3 className={styles.featuresTitle}>What's Included</h3>
              <ul className={styles.featuresList}>
                <li>✓ Real-time dietary analysis for menu items</li>
                <li>✓ Batch processing (up to 25 items per API call)</li>
                <li>✓ User dietary preference checking</li>
                <li>✓ Usage dashboard and analytics</li>
                <li>✓ 24/7 API access</li>
                <li>✓ Automatic scaling with your business</li>
              </ul>
            </div>

            <button 
              className={styles.subscribeButton}
              onClick={handleSubscribe}
            >
              Get Started
            </button>

            <p className={styles.note}>
              No setup fees. No contracts. Cancel anytime.
            </p>
          </div>
        </div>
      </PageBody>
    </PageContainer>
  );
};

export default Pricing;